(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  // Keep the theme's slideshow, editor blocks, dots and player. Only its mobile
  // gesture input changes; desktop returns to the original fade configuration.
  const selector = '[data-vp-native-swipe]';
  const instances = new Map();
  const pending = new Map();

  class VPMobileNativeSwipe {
    constructor(root, flickity) {
      this.root = root;
      this.flkty = flickity;
      this.surface = flickity.viewport;
      this.mobile = matchMedia('(max-width: 767px)');
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.original = { fade: flickity.options.fade, draggable: flickity.options.draggable };
      this.events = new AbortController();
      this.enabled = false;
      this.sync = () => this.syncMode();
      this.on(this.surface, 'pointerdown', event => this.down(event));
      this.on(this.surface, 'pointermove', event => this.move(event), { passive: true });
      this.on(this.surface, 'pointerup', event => this.up(event));
      this.on(this.surface, 'pointercancel', event => {
        if (this.gesture?.id === event.pointerId) this.cancel();
      });
      this.on(this.surface, 'lostpointercapture', event => {
        // A descendant's implicit capture may transfer to the viewport mid-drag.
        if (event.target === this.surface && this.gesture?.id === event.pointerId &&
            !this.surface.hasPointerCapture(event.pointerId)) this.cancel();
      });
      this.on(this.surface, 'touchmove', event => this.touchMove(event), { passive: false, capture: true });
      this.on(this.surface, 'click', event => {
        if (event.detail !== 0 && performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true });
      this.on(this.surface, 'dragstart', event => { if (this.enabled) event.preventDefault(); });
      this.on(this.mobile, 'change', this.sync);
      this.on(window, 'resize', () => { if (this.gesture) this.cancel(); });
      this.on(document, 'visibilitychange', () => { if (document.hidden) this.cancel(); });
      this.on(root, 'shopify:block:select', () => this.cancel(), { capture: true });
      this.syncMode();
    }
    on(target, type, callback, options = {}) {
      target.addEventListener(type, callback, { ...options, signal: this.events.signal });
    }
    syncMode() {
      const enabled = this.mobile.matches && Boolean(window.PointerEvent);
      if (enabled === this.enabled) return;
      this.cancel();
      const f = this.flkty;
      f.isAnimating = false;
      f.velocity = 0;
      this.enabled = enabled;
      if (enabled) {
        // Unbind the library's pointer owner, instead of running two recognizers.
        f.unbindHandles();
        f.options.fade = false;
        f.options.draggable = false;
        f.element.classList.remove('is-fade');
        f.slides.forEach(slide => slide.setOpacity(''));
      } else {
        Object.assign(f.options, this.original);
        f.element.classList.toggle('is-fade', Boolean(this.original.fade));
        f.bindHandles();
      }
      f.updateDraggable();
      f.resize();
      f.reposition();
      this.root.toggleAttribute('data-vp-mobile-swipe-ready', enabled);
    }
    axis(gesture, x, y) {
      if (gesture.axis) return gesture.axis;
      const dx = Math.abs(x - gesture.x), dy = Math.abs(y - gesture.y);
      if (dx >= 8 && dx > dy * 1.1) gesture.axis = 'x';
      else if (dy >= 8 && dy > dx * 1.1) gesture.axis = 'y';
      return gesture.axis;
    }
    down(event) {
      if (!this.enabled) return;
      if (!event.isPrimary) { this.cancel(); return; }
      if (event.button || event.target.closest('button,input,select,textarea,[contenteditable]')) return;
      this.suppressClickUntil = 0;
      this.cancel();
      const box = this.surface.getBoundingClientRect();
      // Leave the browser's edge-back gesture and pinch zoom available.
      if (event.clientX < 12 || innerWidth - event.clientX < 12) return;
      this.flkty.stopPlayer();
      this.gesture = { id: event.pointerId, pointerType: event.pointerType, axis: null,
        x: event.clientX, y: event.clientY, width: box.width,
        samples: [{ x: event.clientX, time: performance.now() }] };
    }
    begin(gesture) {
      const f = this.flkty;
      f.positionSliderAtSelected();
      f.isPointerDown = true;
      f.isDragging = true;
      gesture.dragging = true;
      gesture.start = f.x;
      gesture.index = f.selectedIndex;
      f.dragX = f.x;
      try { this.surface.setPointerCapture(gesture.id); } catch (_) { /* Cancel can win the capture race. */ }
    }
    move(event) {
      const gesture = this.gesture;
      if (!gesture || gesture.id !== event.pointerId) return;
      const axis = this.axis(gesture, event.clientX, event.clientY);
      if (axis === 'y') { this.cancel(); return; }
      if (axis !== 'x') return;
      if (!gesture.dragging) this.begin(gesture);
      const now = performance.now();
      gesture.samples.push({ x: event.clientX, time: now });
      gesture.samples = gesture.samples.filter(sample => now - sample.time <= 120);
      this.renderDrag(event.clientX - gesture.x);
    }
    renderDrag(dx) {
      const gesture = this.gesture;
      const f = this.flkty;
      let offset = Math.max(-gesture.width, Math.min(gesture.width, dx));
      if (f.options.rightToLeft) offset *= -1;
      let x = gesture.start + offset;
      if (!f.isWrapping) {
        const first = -f.slides[0].target;
        const last = -f.slides[f.slides.length - 1].target;
        if (x > first) x = first + (x - first) * .25;
        if (x < last) x = last + (x - last) * .25;
      }
      f.x = f.dragX = x;
      f.velocity = 0;
      f.positionSlider();
    }
    touchMove(event) {
      const gesture = this.gesture;
      if (!gesture || gesture.pointerType !== 'touch') return;
      if (event.touches.length !== 1) { this.cancel(); return; }
      const touch = event.touches[0];
      if (gesture.touchId == null) gesture.touchId = touch.identifier;
      if (gesture.touchId !== touch.identifier) { this.cancel(); return; }
      const axis = this.axis(gesture, touch.clientX, touch.clientY);
      if (axis === 'y') this.cancel();
      else if (axis === 'x' && event.cancelable) event.preventDefault();
    }
    up(event) {
      const gesture = this.gesture;
      if (!gesture || gesture.id !== event.pointerId) return;
      if (!gesture.dragging) { this.gesture = null; return; }
      this.renderDrag(event.clientX - gesture.x);
      const dx = event.clientX - gesture.x;
      const sample = gesture.samples[0];
      const elapsed = performance.now() - sample.time;
      const velocity = elapsed > 0 && elapsed < 160 ? (event.clientX - sample.x) / elapsed : 0;
      const farEnough = Math.abs(dx) >= Math.max(24, Math.min(32, gesture.width * .1));
      const flick = Math.abs(dx) >= 16 && Math.abs(velocity) > .25 && Math.sign(velocity) === Math.sign(dx);
      let step = farEnough || flick ? (dx < 0 ? 1 : -1) : 0;
      if (this.flkty.options.rightToLeft) step *= -1;
      const index = gesture.index + step;
      event.preventDefault();
      this.suppressClickUntil = performance.now() + 450;
      this.releaseCapture();
      this.flkty.velocity = 0;
      // Native selection owns dots, aria state, spring motion and editor integration.
      this.flkty.select(this.flkty.isWrapping ? index : Math.max(0, Math.min(index, this.flkty.slides.length - 1)),
        false, this.reduce.matches);
    }
    releaseCapture() {
      const gesture = this.gesture;
      this.gesture = null;
      this.flkty.isPointerDown = false;
      this.flkty.isDragging = false;
      if (gesture && this.surface.hasPointerCapture(gesture.id)) this.surface.releasePointerCapture(gesture.id);
    }
    cancel() {
      const dragged = this.gesture?.dragging;
      this.releaseCapture();
      if (dragged) {
        this.suppressClickUntil = performance.now() + 450;
        this.flkty.isAnimating = false;
        this.flkty.positionSliderAtSelected();
      }
    }
    destroy() {
      this.cancel();
      this.events.abort();
      if (this.enabled && this.flkty.isActive) {
        Object.assign(this.flkty.options, this.original);
        this.flkty.element.classList.toggle('is-fade', Boolean(this.original.fade));
        this.flkty.bindHandles();
        this.flkty.updateDraggable();
        this.flkty.reposition();
      }
      this.root.removeAttribute('data-vp-mobile-swipe-ready');
    }
  }
  function init(scope) {
    const roots = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) roots.unshift(scope);
    roots.forEach(root => {
      if (instances.has(root) || pending.has(root)) return;
      let attempts = 0;
      const ready = () => {
        if (!root.isConnected) { pending.delete(root); return; }
        const wrapper = root.querySelector('[data-slideshow-wrapper]');
        const f = window.themeVendor?.FlickityFade?.data(wrapper);
        if (f?.isActive) {
          pending.delete(root);
          instances.set(root, new VPMobileNativeSwipe(root, f));
        } else if (++attempts < 100) pending.set(root, setTimeout(ready, 100));
        else pending.delete(root);
      };
      ready();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, timer] of pending) if (event.target.contains(root)) { clearTimeout(timer); pending.delete(root); }
    for (const [root, instance] of instances) if (event.target.contains(root)) { instance.destroy(); instances.delete(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-collection-gallery"] && !Shopify.designMode) return;
  try {
    
/* VerdiPot Collection Gallery. No dependencies; intentionally scoped to this section. */
(() => {
  'use strict';
  const ROOT = '[data-vp-collection-gallery]';
  if (window.VPCollectionGallery) {
    window.VPCollectionGallery.init(document);
    return;
  }
  const instances = new Map();
  const now = () => performance.now();
  const clampNumber = (value, fallback, min, max) => {
    const number = Number(value);
    return Number.isFinite(number) ? Math.min(max, Math.max(min, number)) : fallback;
  };

  class Gallery {
    constructor(root) {
      this.root = root;
      this.destroyed = false;
      this.epoch = 0;
      this.timer = null;
      this.busy = false;
      this.pending = null;
      this.editorQueue = [];
      this.recoveryQueue = [];
      this.animations = [];
      this.disposers = [];
      this.loadDisposers = new Set();
      this.userPaused = false;
      this.pageHidden = false;
      this.sectionSelected = false;
      this.selectedBlocks = new Set();
      this.editorPlay = false;
      this.pointerFocusUntil = -Infinity;
      this.keyboardIntent = false;
      this.inspect = !!(window.Shopify && window.Shopify.inspectMode);
      this.lastAutoStart = -Infinity;
      this.lastCard = -1;
      this.dwell = clampNumber(root.dataset.dwell, 6000, 1000, 60000);
      this.interval = clampNumber(root.dataset.interval, 7000, 1000, 60000);
      this.duration = clampNumber(root.dataset.duration, 1000, 0, 5000);
      this.toggle = root.querySelector('[data-vp-toggle]');
      this.status = root.querySelector('[data-vp-status]');
      this.desktopQuery = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
      this.mobileQuery = window.matchMedia('(max-width: 767px)');
      this.reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.designMode = !!(window.Shopify && window.Shopify.designMode);
      this.cards = Array.from(root.querySelectorAll('[data-vp-card]')).map((element, index) => {
        const media = element.querySelector('[data-vp-media]');
        const entries = [];
        if (media) {
          Array.from(media.children).forEach(child => {
            if (child.matches('[data-vp-slide]')) {
              entries.push({slot: child.dataset.slot, element: child, template: null, state: 'initial'});
            } else if (child.matches('template[data-vp-template]')) {
              entries.push({slot: child.dataset.slot, element: null, template: child, state: 'idle'});
            }
          });
        }
        entries.sort((a, b) => Number(a.slot) - Number(b.slot));
        const current = entries.find(entry => entry.element) || null;
        return {
          element, media, entries, current, index,
          title: element.dataset.title || 'Collection',
          blockId: element.dataset.blockId,
          near: false, visible: false, visibleSince: Infinity,
          controls: element.querySelector('[data-vp-controls]'),
          dots: Array.from(element.querySelectorAll('[data-vp-dot]')),
          product: element.querySelector('[data-vp-product]'),
          gesture: null, suppressClickUntil: 0
        };
      });
      try {
        this.cards.forEach(card => this.bindCard(card));
        this.bindEvents();
        this.observe();
        this.normalize();
        this.updateControls();
        root.dataset.vpEnhanced = 'true';
        this.cards.forEach(card => {
          if (card.current) this.watchCover(card);
        });
        if (this.designMode) this.previewEditorImages();
        this.schedule();
      } catch (error) {
        this.destroy();
        throw error;
      }
    }

    listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      this.disposers.push(() => target.removeEventListener(type, handler, options));
    }

    automaticMode() {
      return this.root.dataset.autoplay === 'true' && this.desktopQuery.matches && !this.reduceQuery.matches;
    }

    manualAllowed() {
      return this.desktopQuery.matches || this.root.dataset.mobile !== 'static';
    }

    allowed() {
      return !this.destroyed && this.automaticMode() && !this.userPaused &&
        !document.hidden && !this.pageHidden && !this.editorPaused();
    }

    editorPaused() {
      return this.selectedBlocks.size > 0 && !this.editorPlay;
    }

    usable(card) {
      return card.entries.filter(entry => entry.state !== 'failed');
    }

    clearSchedule() {
      if (this.timer !== null) window.clearTimeout(this.timer);
      this.timer = null;
    }

    resetDwell() {
      const time = now();
      this.cards.forEach(card => { if (card.visible) card.visibleSince = time; });
    }

    invalidate(resetDwell = false) {
      this.epoch += 1;
      this.cards.forEach(card => this.cancelSwipe(card));
      this.clearSchedule();
      this.animations.forEach(animation => animation.cancel());
      this.animations = [];
      if (resetDwell) this.resetDwell();
      if (!this.destroyed) this.normalize();
    }

    pauseByUser() {
      this.userPaused = true;
      this.pending = null;
      this.editorQueue = [];
      this.invalidate();
      this.updateControls();
    }

    bindEvents() {
      this.listen(this.root, 'pointerdown', () => {
        this.pointerFocusUntil = now() + 1000;
        this.keyboardIntent = false;
      }, {capture: true, passive: true});
      this.listen(document, 'keydown', () => {
        this.pointerFocusUntil = -Infinity;
        this.keyboardIntent = true;
      }, {capture: true});
      this.listen(this.root, 'focusin', event => {
        // Keyboard entry stops rotation; focusing an already-stopped Play button must not undo Play.
        if (this.toggle && (event.target === this.toggle || this.toggle.contains(event.target))) {
          if (this.userPaused || this.editorPaused() || this.togglePointerIntent) { this.togglePointerIntent = false; return; }
        }
        // A mouse/touch click can focus a collection link or an editor selection. It is not
        // an instruction to stop every slideshow permanently. Keyboard focus still is.
        if (now() <= this.pointerFocusUntil) return;
        const focusVisible = event.target.matches && event.target.matches(':focus-visible');
        if (!this.keyboardIntent && !focusVisible) return;
        this.pauseByUser();
      });
      if (this.toggle) {
        this.listen(this.toggle, 'pointerdown', () => { this.togglePointerIntent = true; });
        this.listen(this.toggle, 'pointercancel', () => { this.togglePointerIntent = false; });
        this.listen(this.toggle, 'click', () => {
        this.togglePointerIntent = false;
        if (!this.automaticMode()) return;
        if (this.userPaused || this.editorPaused()) {
          this.userPaused = false;
          this.editorPlay = true;
          this.invalidate(true);
          this.schedule();
        } else this.pauseByUser();
        this.updateControls();
      });
      }
      const modeChange = () => {
        this.pending = null;
        this.invalidate(true);
        this.updateControls();
        this.measureAll();
        this.cards.filter(card => card.near).forEach(card => this.prepareSwipe(card));
        this.schedule();
      };
      [this.desktopQuery, this.mobileQuery, this.reduceQuery].forEach(query => {
        if (query.addEventListener) this.listen(query, 'change', modeChange);
        else {
          query.addListener(modeChange);
          this.disposers.push(() => query.removeListener(modeChange));
        }
      });
      this.listen(document, 'visibilitychange', () => {
        this.pending = null;
        this.invalidate(true);
        this.schedule();
      });
      this.listen(window, 'pagehide', () => {
        this.pageHidden = true;
        this.pending = null;
        this.invalidate(true);
      });
      this.listen(window, 'pageshow', () => {
        this.pageHidden = false;
        this.invalidate(true);
        this.measureAll();
        this.schedule();
      });
      this.listen(window, 'resize', () => {
        this.cards.forEach(card => this.cancelSwipe(card));
        this.measureAll();
      }, {passive: true});
      // Geometry also covers unusually tall cards whose viewport-based threshold can lie
      // between observer ratios. No animation frame loop runs while the page is idle.
      this.listen(window, 'scroll', () => this.measureAll(), {passive: true});
    }

    bindCard(card) {
      card.dots.forEach(dot => this.listen(dot, 'click', () => {
        const entry = this.usable(card).find(item => item.slot === dot.dataset.slot);
        if (!entry || !this.manualAllowed() || this.usable(card).length < 2) return;
        this.pauseByUser();
        this.enqueue({card, entry, kind: 'manual'});
      }));
      this.listen(card.element, 'keydown', event => {
        if ((event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') ||
          event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || !this.manualAllowed()) return;
        const target = event.target;
        if (!target.closest || target.closest('input, textarea, select, [contenteditable]') ||
          !target.closest('a') || this.usable(card).length < 2) return;
        event.preventDefault();
        this.manualStep(card, event.key === 'ArrowLeft' ? -1 : 1);
      });
      if (!card.media) return;
      this.bindSwipe(card);
      this.listen(card.element, 'pointerdown', event => {
        if (this.mobileQuery.matches || event.pointerType === 'mouse' || !this.manualAllowed()) return;
        if (!event.isPrimary) { card.gesture = null; return; }
        if (event.target.closest && event.target.closest('button, [data-vp-product]')) return;
        card.gesture = {id: event.pointerId, x: event.clientX, y: event.clientY, time: now()};
      }, {passive: true});
      this.listen(card.element, 'pointerup', event => {
        if (this.mobileQuery.matches) return;
        const gesture = card.gesture;
        card.gesture = null;
        if (!gesture || gesture.id !== event.pointerId || now() - gesture.time > 1500) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        if (this.usable(card).length < 2) return;
        card.suppressClickUntil = now() + 500;
        this.manualStep(card, dx < 0 ? 1 : -1);
      }, {passive: true});
      this.listen(card.element, 'pointercancel', () => {
        if (!this.mobileQuery.matches) card.gesture = null;
      }, {passive: true});
      this.listen(card.element, 'click', event => {
        if (event.detail !== 0 && now() < card.suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
          card.suppressClickUntil = 0;
        }
      }, true);
    }

    bindSwipe(card) {
      const surface = card.media;
      this.listen(surface, 'dragstart', event => {
        if (this.mobileQuery.matches && this.manualAllowed()) event.preventDefault();
      });
      this.listen(surface, 'pointerdown', event => {
        if (!this.mobileQuery.matches || !this.manualAllowed() || this.usable(card).length < 2) return;
        if (!event.isPrimary) { this.cancelSwipe(card); return; }
        if (event.button !== 0 || event.target.closest('button,input,select,textarea,[contenteditable]')) return;
        // Keep the native anchor target on taps. Capture begins only after horizontal intent.
        this.cancelSwipe(card);
        card.suppressClickUntil = 0;
        this.prepareSwipe(card);
        card.gesture = {id: event.pointerId, pointerType: event.pointerType, axis: null,
          x: event.clientX, y: event.clientY, samples: [{x: event.clientX, time: now()}]};
      });
      this.listen(surface, 'pointermove', event => {
        const gesture = card.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        const axis = this.swipeAxis(gesture, event.clientX, event.clientY);
        if (axis === 'y') { this.cancelSwipe(card); return; }
        if (axis !== 'x') return;
        if (!card.swipe) {
          // Existing manual transitions are invalidated before taking visual ownership.
          this.pauseByUser();
          card.gesture = gesture;
          const width = surface.getBoundingClientRect().width;
          card.swipe = {id: gesture.id, width, offset: 0, rendered: 0, direction: 1,
            current: card.current, incoming: null, animations: [], ending: false};
          surface.classList.add('is-swiping');
          try { surface.setPointerCapture(gesture.id); } catch (_) { /* The pointer may already be cancelled. */ }
        }
        const time = now();
        gesture.samples.push({x: event.clientX, time});
        gesture.samples = gesture.samples.filter(sample => time - sample.time <= 120);
        this.moveSwipe(card, event.clientX - gesture.x);
      }, {passive: true});
      this.listen(surface, 'touchmove', event => {
        const gesture = card.gesture;
        if (!gesture || gesture.pointerType !== 'touch') return;
        // Pointer Events render and commit. This local bridge only stops native Y drift
        // after the one-way direction decision, regardless of touch/pointer event order.
        if (event.touches.length !== 1) { this.cancelSwipe(card); return; }
        const touch = event.touches[0];
        if (gesture.touchId == null) gesture.touchId = touch.identifier;
        if (gesture.touchId !== touch.identifier) { this.cancelSwipe(card); return; }
        const axis = this.swipeAxis(gesture, touch.clientX, touch.clientY);
        if (axis === 'y') { this.cancelSwipe(card); return; }
        if (axis === 'x' && event.cancelable) event.preventDefault();
      }, {passive: false, capture: true});
      this.listen(surface, 'pointerup', event => {
        const gesture = card.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        card.gesture = null;
        const swipe = card.swipe;
        if (!swipe) return;
        this.moveSwipe(card, event.clientX - gesture.x);
        const sample = gesture.samples[0];
        const elapsed = now() - sample.time;
        const velocity = elapsed > 0 && elapsed < 160 ? (event.clientX - sample.x) / elapsed : 0;
        const dx = event.clientX - gesture.x;
        const farEnough = Math.abs(dx) >= Math.max(24, Math.min(32, swipe.width * .1));
        const flick = Math.abs(dx) >= 16 && Math.abs(velocity) > .25 && Math.sign(velocity) === Math.sign(dx);
        event.preventDefault();
        card.suppressClickUntil = now() + 500;
        this.releaseSwipePointer(card, swipe.id);
        this.finishSwipe(card, farEnough || flick);
      });
      this.listen(surface, 'pointercancel', event => {
        if (card.gesture && card.gesture.id === event.pointerId) this.cancelSwipe(card);
      });
      this.listen(surface, 'lostpointercapture', event => {
        // Implicit capture transfers from an image-link descendant; ignore its bubbled loss.
        if (event.target === surface && card.gesture && card.gesture.id === event.pointerId &&
            !surface.hasPointerCapture(event.pointerId)) this.cancelSwipe(card);
      });
    }

    swipeAxis(gesture, x, y) {
      if (gesture.axis) return gesture.axis;
      const dx = Math.abs(x - gesture.x), dy = Math.abs(y - gesture.y);
      if (dx >= 8 && dx > dy * 1.1) gesture.axis = 'x';
      else if (dy >= 8 && dy > dx * 1.1) gesture.axis = 'y';
      return gesture.axis;
    }

    prepareSwipe(card) {
      if (!this.mobileQuery.matches || !this.manualAllowed()) return;
      // Mobile neighbors load only near the screen or on intent. Desktop keeps its
      // original serialized hydration queue and autoplay cadence.
      this.usable(card).forEach(entry => {
        if (entry === card.current) return;
        this.ready(card, entry).then(() => {
          if (this.destroyed) return;
          if (card.swipe && !card.swipe.ending) this.moveSwipe(card, card.swipe.offset);
          this.updateCard(card);
        });
      });
    }

    moveSwipe(card, offset) {
      const swipe = card.swipe;
      if (!swipe || swipe.ending) return;
      swipe.offset = Math.max(-swipe.width, Math.min(swipe.width, offset));
      swipe.direction = offset < 0 ? 1 : -1;
      const incoming = this.relativeEntry(card, swipe.direction, swipe.current);
      if (swipe.incoming && swipe.incoming !== incoming) this.resetSwipeEntry(swipe.incoming, false);
      swipe.incoming = incoming !== swipe.current ? incoming : null;
      // An unready neighbor never reveals a blank frame. A release can wait for its
      // existing bounded loader while the current image remains in place.
      swipe.rendered = swipe.incoming && swipe.incoming.state === 'ready' ? swipe.offset : 0;
      swipe.current.element.style.transform = `translateX(${swipe.rendered}px)`;
      swipe.current.element.style.willChange = 'transform';
      if (!swipe.incoming || swipe.incoming.state !== 'ready') return;
      const element = swipe.incoming.element;
      element.hidden = false;
      element.inert = true;
      element.setAttribute('aria-hidden', 'true');
      element.style.opacity = '1';
      element.style.willChange = 'transform';
      element.style.transform = `translateX(${swipe.direction * swipe.width + swipe.rendered}px)`;
    }

    async finishSwipe(card, commit) {
      const swipe = card.swipe;
      if (!swipe) return;
      swipe.ending = true;
      const incoming = swipe.incoming;
      if (commit && incoming && incoming.state !== 'ready') {
        const loaded = await this.ready(card, incoming);
        if (card.swipe !== swipe || this.destroyed) return;
        commit = loaded;
      }
      commit = commit && !!incoming && incoming.state === 'ready';
      const previous = swipe.current.element;
      const next = incoming && incoming.state === 'ready' ? incoming.element : null;
      if (next) {
        next.hidden = false;
        next.inert = true;
        next.style.opacity = '1';
        next.style.transform = `translateX(${swipe.direction * swipe.width + swipe.rendered}px)`;
      }
      const target = commit ? -swipe.direction * swipe.width : 0;
      const duration = this.reduceQuery.matches ? 0 : commit ? 300 : 240;
      if (duration && previous.animate) {
        const options = {duration, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both'};
        swipe.animations.push(previous.animate([
          {transform: `translateX(${swipe.rendered}px)`}, {transform: `translateX(${target}px)`}
        ], options));
        if (next) swipe.animations.push(next.animate([
          {transform: `translateX(${swipe.direction * swipe.width + swipe.rendered}px)`},
          {transform: `translateX(${swipe.direction * swipe.width + target}px)`}
        ], options));
        await Promise.all(swipe.animations.map(animation => animation.finished.catch(() => {})));
      }
      if (card.swipe !== swipe || this.destroyed) return;
      if (commit) card.current = incoming;
      this.cancelSwipe(card);
      this.updateCard(card);
      if (commit && this.status) {
        this.status.textContent = `${card.title}: image ${this.usable(card).indexOf(card.current) + 1} of ${this.usable(card).length}.`;
      }
    }

    releaseSwipePointer(card, id) {
      try { if (card.media.hasPointerCapture(id)) card.media.releasePointerCapture(id); }
      catch (_) { /* The browser may have released capture already. */ }
    }

    resetSwipeEntry(entry, active) {
      if (!entry || !entry.element) return;
      const element = entry.element;
      element.hidden = !active;
      element.inert = !active;
      element.setAttribute('aria-hidden', active ? 'false' : 'true');
      element.toggleAttribute('data-active', active);
      element.style.transform = '';
      element.style.opacity = '';
      element.style.willChange = '';
    }

    cancelSwipe(card) {
      const gesture = card.gesture, swipe = card.swipe;
      card.gesture = null;
      card.swipe = null;
      if (gesture) this.releaseSwipePointer(card, gesture.id);
      if (!swipe) return;
      card.suppressClickUntil = now() + 500;
      swipe.animations.forEach(animation => animation.cancel());
      this.releaseSwipePointer(card, swipe.id);
      card.entries.forEach(entry => this.resetSwipeEntry(entry, entry === card.current));
      card.media.classList.remove('is-swiping');
    }

    observe() {
      if (window.IntersectionObserver) {
        this.nearObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const card = this.cards.find(item => item.media === entry.target);
            if (card) {
              card.near = entry.isIntersecting;
              if (card.near) this.prepareSwipe(card);
            }
          });
          // Near-screen status never starts the visibility dwell or playback clock.
        }, {rootMargin: '240px 0px', threshold: 0});
        this.visibleObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const card = this.cards.find(item => item.media === entry.target);
            if (card) this.measure(card);
          });
          this.schedule();
        }, {threshold: Array.from({length: 21}, (_, index) => index / 20)});
        this.cards.forEach(card => {
          if (card.media) {
            this.nearObserver.observe(card.media);
            this.visibleObserver.observe(card.media);
          }
        });
      }
      this.measureAll();
    }

    measure(card) {
      if (!card.media) return;
      const box = card.media.getBoundingClientRect();
      const height = window.innerHeight || document.documentElement.clientHeight;
      const width = window.innerWidth || document.documentElement.clientWidth;
      const visibleHeight = Math.max(0, Math.min(box.bottom, height) - Math.max(box.top, 0));
      const visibleWidth = Math.max(0, Math.min(box.right, width) - Math.max(box.left, 0));
      const visible = box.height > 0 && box.width > 0 &&
        visibleHeight >= Math.min(box.height, height) * .35 &&
        visibleWidth >= Math.min(box.width, width) * .35;
      const wasNear = card.near;
      card.near = box.bottom > -240 && box.top < height + 240;
      if (card.near && !wasNear) this.prepareSwipe(card);
      if (visible !== card.visible) {
        card.visible = visible;
        card.visibleSince = visible ? now() : Infinity;
        if (!visible && this.activeCard === card) this.invalidate();
      }
    }

    measureAll() {
      if (this.destroyed) return;
      this.cards.forEach(card => this.measure(card));
      this.schedule();
    }

    candidate() {
      const time = now();
      for (let offset = 1; offset <= this.cards.length; offset += 1) {
        const card = this.cards[(this.lastCard + offset) % this.cards.length];
        if (card.near && card.visible && this.usable(card).length > 1 && time >= card.visibleSince + this.dwell) return card;
      }
      return null;
    }

    schedule() {
      this.clearSchedule();
      if (!this.allowed() || this.busy || this.pending || this.editorQueue.length || this.recoveryQueue.length) return;
      const candidates = this.cards.filter(card => card.visible && this.usable(card).length > 1);
      if (!candidates.length) return;
      const earliestDwell = Math.min(...candidates.map(card => card.visibleSince + this.dwell));
      const due = Math.max(earliestDwell, this.lastAutoStart + this.interval);
      this.timer = window.setTimeout(() => {
        this.timer = null;
        if (!this.allowed()) return;
        const card = this.candidate();
        if (!card) { this.schedule(); return; }
        this.enqueue({card, entry: this.relativeEntry(card, 1), kind: 'auto'});
      }, Math.max(0, due - now()));
    }

    relativeEntry(card, direction, base = card.current) {
      const entries = this.usable(card);
      if (!entries.length) return null;
      const index = entries.indexOf(base);
      return entries[(Math.max(index, 0) + direction + entries.length) % entries.length];
    }

    manualStep(card, direction) {
      if (!this.manualAllowed() || this.usable(card).length < 2) return;
      // Rapid presses advance from the requested destination, retaining only the latest request.
      const base = this.pending && this.pending.card === card ? this.pending.entry :
        this.activeRequest && this.activeRequest.card === card ? this.activeRequest.entry : card.current;
      const entry = this.relativeEntry(card, direction, base);
      this.pauseByUser();
      this.enqueue({card, entry, kind: 'manual'});
    }

    enqueue(request) {
      if (this.destroyed || !request.entry) return;
      if (request.kind === 'recovery') {
        this.recoveryQueue = this.recoveryQueue.filter(item => item.card !== request.card);
        this.recoveryQueue.push(request);
      } else this.pending = request;
      this.pump();
    }

    async pump() {
      if (this.busy || this.destroyed || (!this.pending && !this.editorQueue.length && !this.recoveryQueue.length)) return;
      const request = this.pending || this.recoveryQueue.shift() || this.editorQueue.shift();
      this.pending = null;
      this.busy = true;
      this.activeRequest = request;
      this.activeCard = request.card;
      const token = this.epoch;
      try {
        await this.perform(request, token);
      } catch (error) {
        // Resource failures are handled below; unexpected failures keep the server cover usable.
        if (!this.destroyed) console.warn('[VP Collection Gallery] Image transition unavailable.', error);
      } finally {
        this.busy = false;
        this.activeRequest = null;
        this.activeCard = null;
        if (!this.destroyed) {
          this.normalize();
          this.updateControls();
          if (this.pending || this.editorQueue.length || this.recoveryQueue.length) this.pump();
          else this.schedule();
        }
      }
    }

    hydrate(card, entry) {
      if (entry.element) return entry.element;
      const fragment = entry.template.content.cloneNode(true);
      const element = fragment.querySelector('[data-vp-slide]');
      if (!element) throw new Error('Missing image slide');
      element.hidden = true;
      element.inert = true;
      element.setAttribute('aria-hidden', 'true');
      element.removeAttribute('data-active');
      // A complete picture is inserted once; inactive templates cannot request images.
      card.media.appendChild(fragment);
      entry.element = element;
      return element;
    }

    ready(card, entry) {
      if (entry.state === 'ready') return Promise.resolve(true);
      if (entry.state === 'failed') return Promise.resolve(false);
      if (entry.loading) return entry.loading;
      const element = this.hydrate(card, entry);
      const img = element.querySelector('img');
      if (!img) { entry.state = 'failed'; return Promise.resolve(false); }
      // User intent / scheduler hydration should not be stalled by native lazy loading.
      if (entry.template) img.loading = 'eager';
      entry.loading = new Promise(resolve => {
        let ended = false;
        let decoding = false;
        const finish = success => {
          if (ended) return;
          ended = true;
          window.clearTimeout(timeout);
          img.removeEventListener('load', loaded);
          img.removeEventListener('error', failed);
          this.loadDisposers.delete(cancel);
          if (!this.destroyed) entry.state = success ? 'ready' : 'failed';
          resolve(success);
        };
        const failed = () => finish(false);
        const loaded = () => {
          if (ended || decoding) return;
          if (!img.naturalWidth) { failed(); return; }
          decoding = true;
          if (typeof img.decode === 'function') {
            img.decode().then(() => finish(true), () => finish(img.complete && img.naturalWidth > 0));
          } else finish(true);
        };
        const cancel = () => finish(false);
        // A slow or never-settling decode cannot hold the gallery queue indefinitely.
        const timeout = window.setTimeout(failed, 12000);
        this.loadDisposers.add(cancel);
        img.addEventListener('load', loaded);
        img.addEventListener('error', failed);
        if (img.complete) loaded();
      });
      return entry.loading;
    }

    async perform(request, token) {
      const {card, entry, kind} = request;
      if (entry === card.current && entry.state !== 'failed') return;
      const loaded = await this.ready(card, entry);
      if (this.destroyed || token !== this.epoch) return;
      if (!loaded) {
        if (kind === 'manual' && this.status) this.status.textContent = `${card.title}: image unavailable. Current image kept.`;
        if (kind === 'recovery') {
          const replacement = this.usable(card).find(item => item !== card.current);
          if (replacement) this.enqueue({card, entry: replacement, kind: 'recovery'});
        }
        return;
      }
      if (kind === 'auto' && (!this.allowed() || !card.visible || now() < card.visibleSince + this.dwell)) return;
      if (kind === 'manual' && !this.manualAllowed()) return;
      const previous = card.current;
      const incoming = entry.element;
      incoming.hidden = false;
      incoming.inert = true;
      incoming.setAttribute('aria-hidden', 'true');
      incoming.setAttribute('data-active', '');
      if (card.product) card.product.hidden = true;
      if (kind === 'auto') {
        this.lastAutoStart = now();
        this.lastCard = card.index;
      }
      const duration = this.reduceQuery.matches || kind === 'editor' || kind === 'recovery' ? 0 :
        kind === 'auto' ? this.duration : Math.min(this.duration, 260);
      if (duration && incoming.animate && previous && previous.element) {
        incoming.style.willChange = 'opacity';
        incoming.style.zIndex = '2';
        previous.element.style.zIndex = '1';
        this.animations = [
          incoming.animate([{opacity: 0}, {opacity: 1}], {duration, easing: 'ease-in-out', fill: 'both'})
        ];
        await Promise.all(this.animations.map(animation => animation.finished.catch(() => {})));
      }
      if (this.destroyed || token !== this.epoch) return;
      card.current = entry;
      this.animations.forEach(animation => animation.cancel());
      this.animations = [];
      this.normalize();
      this.updateCard(card);
      if (kind === 'manual' && this.status) {
        this.status.textContent = `${card.title}: image ${this.usable(card).indexOf(entry) + 1} of ${this.usable(card).length}.`;
      }
    }

    normalize() {
      this.cards.forEach(card => card.entries.forEach(entry => {
        if (card.swipe) return;
        if (!entry.element) return;
        const active = entry === card.current;
        entry.element.hidden = !active;
        entry.element.inert = !active;
        entry.element.setAttribute('aria-hidden', active ? 'false' : 'true');
        entry.element.toggleAttribute('data-active', active);
        entry.element.style.willChange = '';
        entry.element.style.zIndex = '';
      }));
    }

    updateCard(card) {
      const entries = this.usable(card);
      if (card.controls) card.controls.hidden = entries.length < 2 || !this.manualAllowed();
      card.element.toggleAttribute('data-vp-multiple', entries.length > 1);
      card.dots.forEach(dot => {
        const entry = entries.find(item => item.slot === dot.dataset.slot);
        dot.hidden = !entry;
        dot.setAttribute('aria-current', entry && entry === card.current ? 'true' : 'false');
      });
      if (card.product) {
        const data = card.current && card.current.element ? card.current.element.dataset : {};
        const show = !!(card.current && card.current.state !== 'failed' && data.productUrl && data.productLabel);
        card.product.hidden = !show;
        if (show) {
          card.product.setAttribute('href', data.productUrl);
          card.product.textContent = `Shown: ${data.productLabel} ↗`;
        } else card.product.removeAttribute('href');
      }
    }

    updateControls() {
      this.cards.forEach(card => this.updateCard(card));
      if (this.toggle) {
        this.toggle.hidden = !this.automaticMode() || !this.cards.some(card => this.usable(card).length > 1);
        this.toggle.textContent = this.userPaused || this.editorPaused() ? 'Play slideshow' : 'Pause slideshow';
        this.toggle.removeAttribute('aria-pressed');
      }
    }

    watchCover(card) {
      const cover = card.current;
      const img = cover.element.querySelector('img');
      if (!img) return;
      const fail = () => {
        if (this.destroyed || card.current !== cover) return;
        cover.state = 'failed';
        cover.element.style.visibility = 'hidden';
        const replacement = this.usable(card)[0];
        if (replacement) this.enqueue({card, entry: replacement, kind: 'recovery'});
        this.updateControls();
      };
      this.listen(img, 'error', fail);
      if (img.complete && img.naturalWidth === 0) fail();
    }

    previewEditorImages() {
      if (!this.designMode) return;
      // Sequential hydration keeps even editor previews within the single-work limit.
      this.editorQueue = this.cards.map(card => ({
        card, kind: 'editor',
        entry: this.usable(card).find(item => item.slot === (card.element.dataset.preview || '1'))
      })).filter(request => request.entry && request.entry !== request.card.current);
      this.pump();
    }

    editorEvent(type, event) {
      if (type === 'shopify:inspector:activate' || type === 'shopify:inspector:deactivate') {
        this.inspect = type.endsWith(':activate');
        this.invalidate(true);
      } else {
        const detail = event.detail || {};
        const wrapper = this.root.closest('[id^="shopify-section-"]');
        const matches = detail.sectionId ? wrapper && wrapper.id === `shopify-section-${detail.sectionId}` :
          event.target === this.root || (event.target.contains && event.target.contains(this.root));
        if (!matches) return;
        if (type === 'shopify:section:select') this.sectionSelected = true;
        if (type === 'shopify:section:deselect') this.sectionSelected = false;
        if (type === 'shopify:block:select') {
          this.selectedBlocks.add(detail.blockId);
          this.editorPlay = false;
        }
        if (type === 'shopify:block:deselect') this.selectedBlocks.delete(detail.blockId);
        if (type === 'shopify:section:reorder') this.measureAll();
        this.invalidate(true);
        if (type === 'shopify:block:select') {
          const card = this.cards.find(item => item.blockId === detail.blockId);
          if (card) {
            const entry = this.usable(card).find(item => item.slot === (card.element.dataset.preview || '1'));
            if (entry) this.enqueue({card, entry, kind: 'editor'});
          }
        }
      }
      this.updateControls();
      this.schedule();
    }

    destroy() {
      if (this.destroyed) return;
      this.destroyed = true;
      this.invalidate();
      this.pending = null;
      this.editorQueue = [];
      this.recoveryQueue = [];
      this.disposers.splice(0).forEach(dispose => dispose());
      this.loadDisposers.forEach(dispose => dispose());
      this.loadDisposers.clear();
      if (this.nearObserver) this.nearObserver.disconnect();
      if (this.visibleObserver) this.visibleObserver.disconnect();
      instances.delete(this.root);
    }
  }

  function init(scope) {
    const roots = [];
    if (scope.matches && scope.matches(ROOT)) roots.push(scope);
    roots.push(...scope.querySelectorAll(ROOT));
    roots.forEach(root => {
      if (instances.has(root)) return;
      try { instances.set(root, new Gallery(root)); }
      catch (error) {
        delete root.dataset.vpEnhanced;
        root.querySelectorAll('[data-vp-controls], [data-vp-toggle]').forEach(control => { control.hidden = true; });
        console.warn('[VP Collection Gallery] Enhancement unavailable; static cover retained.', error);
      }
    });
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((gallery, root) => {
      if (event.target === root || event.target.contains(root)) gallery.destroy();
    });
  });
  ['shopify:section:select', 'shopify:section:deselect', 'shopify:section:reorder',
    'shopify:block:select', 'shopify:block:deselect', 'shopify:inspector:activate',
    'shopify:inspector:deactivate'].forEach(type => document.addEventListener(type, event => {
    instances.forEach(gallery => gallery.editorEvent(type, event));
  }));
  window.VPCollectionGallery = {version: '1.1.0', init, instances};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  else init(document);
})();

  } catch(e) { console.error(e); }
})();
})();
